import { DATE_VALUES, getRangeFromDateFilter } from 'utils/dateUtils'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from './constants'

const initialState = {
  dateFilter: DATE_VALUES.WEEK,
  dateRange: getRangeFromDateFilter(DATE_VALUES.WEEK),
  withoutScanback: false,
}

export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.value,
          feDateRange: getRangeFromDateFilter(action.payload.value),
        }
      case SCANBACK_CHANGE:
        return { ...state, withoutScanback: action.payload }
      default:
        return state
    }
  }
}
